// TTL para pending push URL: si el user abre por tap de push pero nunca completa
// el login, la url queda en memoria y podria consumirse mucho despues (ej. al dia
// siguiente cuando finalmente loguea) navegando a una ruta que ya no tiene sentido.
// 10 min cubre el caso realista (biometria + retry de mail/pass + verif 2FA).
const MAX_AGE_MS = 10 * 60 * 1000;

let pendingUrl = null;
let pendingAt = 0;

export const setPendingPushUrl = (url) => {
  pendingUrl = url;
  pendingAt = Date.now();
};

export const consumePendingPushUrl = () => {
  if (!pendingUrl) return null;
  const expired = Date.now() - pendingAt > MAX_AGE_MS;
  const url = expired ? null : pendingUrl;
  pendingUrl = null;
  pendingAt = 0;
  return url;
};

// Analogo a pendingUrl pero para acciones de push (botones de la notificacion).
// Necesario para el caso app-killed: el user tapea "Como llegar" pero antes debe
// autenticarse — guardamos {actionId, data} y lo consumimos post-login.
let pendingAction = null;
let pendingActionAt = 0;

export const setPendingPushAction = (action) => {
  pendingAction = action;
  pendingActionAt = Date.now();
};

export const consumePendingPushAction = () => {
  if (!pendingAction) return null;
  const expired = Date.now() - pendingActionAt > MAX_AGE_MS;
  const action = expired ? null : pendingAction;
  pendingAction = null;
  pendingActionAt = 0;
  return action;
};
